import GLightbox from 'glightbox';

export default () => {

    if (document.querySelectorAll('[data-media]')) {
        GLightbox({
            selector: '[data-media]',
            videosWidth: 1130
        });
    }

    if (document.querySelectorAll('[data-hero-video]')) {
        GLightbox({
            selector: '[data-hero-video]',
            videosWidth: 1130
        });
    }


}
